<template>
  <div class="tableWrap">
    <el-table :data="adjustmentList" border size="small" class="wdb100">
      <el-table-column prop="adjustmentNo" label="Quotation (V)" align="center" width="140px"></el-table-column>
      <el-table-column prop="createTime" label="Create Date" align="center" width="250px"></el-table-column>
      <el-table-column prop="country" label="Country" align="center" width="200px"></el-table-column>
      <el-table-column prop="applyReason" label="Description / Apply Reason" align="center" min-width="180px"></el-table-column>
      <el-table-column prop="status" label="Status" align="center" width="150px">
        <template slot-scope="scope">
          <p>{{ adjustmentStatusFormat(scope.row.status) }}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Generic Invoice" width="200px">
        <template slot-scope="scope">
          <template v-if="scope.row.customerInvoice">
            <!-- 普通发票 -->
            <el-button
              type="text"
              size="small"
              @click="invoiceLink(scope.row.customerInvoice.invoiceNumber)"
              v-if="scope.row.customerInvoice?.invoiceType == 1"
            >
              Invoice
            </el-button>
            <!-- 退款发票 -->
            <el-button
              type="text"
              size="small"
              @click="invoiceLink(scope.row.customerInvoice.invoiceNumber)"
              v-if="scope.row.customerInvoice?.invoiceType == 2"
            >
              Credit Invoice
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  props: {
    adjustmentList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    // 发票跳转
    invoiceLink(invoiceNumber) {
      const newPage = `${process.env.VUE_APP_URL_INVOICE}/invoice?invoiceNo=${invoiceNumber}`;
      window.open(newPage, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.tableWrap {
  padding: 6px 120px 6px 22px;

  .to-link {
    cursor: pointer;
    color: #{$--color-primary};
  }
}
</style>
